module.exports = __webpack_public_path__ + "img/meta-logo-white.221458bf.svg";